import { Component, inject, signal } from '@angular/core';
import { type ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  imports: [MatInputModule, MatFormFieldModule, ReactiveFormsModule, FormsModule],
  selector: 'avs-condition-picker',
  templateUrl: './condition-picker.component.html',
})
export class ConditionPickerComponent implements ControlValueAccessor {
  readonly errorMatcher: ErrorStateMatcher = {
    isErrorState: () => {
      return !!(this.ngControl?.control?.invalid && (this.ngControl?.control?.touched || this.ngControl?.control?.dirty));
    },
  };
  ngControl = inject(NgControl, { self: true });
  protected value = signal<string>('');
  protected isDisabled = signal(false);

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange = (_: any) => {
    // replaced in registerOnChange
  };
  onTouched = () => {
    // replaced in registerOnTouched
  };

  onValueChange(newValue: string) {
    this.value.set(newValue);
    this.onChange(newValue);
  }

  writeValue(val: string) {
    this.value.set(val || '');
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled.set(isDisabled);
  }
}
